const DOMAIN = 'https://api.erp.masterkala.com/1.0.0/?route=';
const BASE_URL = 'https://erp.masterkala.com';

export function getCategories(http, start, limit, sort, order, filter, fileType) {
    let req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'categories/getlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function getCategoryType(http, categoryType) {
    const req = {
        "start": "0",
        "limit": "10000",
        "sort": "name",
        "order": "asc",
        "filter": {"category_type_id": categoryType}
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'categories/getlist', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}


export function updateAccountInfo(http, action, editItem) {
    const req = {
        "action": action,
        "obj": editItem
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'accounts/change', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (resp) => {
            if (resp.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            resolve(resp)
        })
    })
}

export function loadAccounts(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'accounts/getlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function getContacts(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'contacts/getlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function contactInfoAction(http, action, editItem) {
    const req = {
        "action": action,
        "obj": editItem
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'contacts/change', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (resp) => {
            if (resp.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            resolve(resp)
        })
    })
}

export function getCategoryTypes(http) {
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'categories/gettypes', '', {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function categoryInfoAction(http, action, editItem) {
    const req = {
        "action": action,
        "obj": editItem
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'categories/change', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (resp) => {
            if (resp.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            
            resolve(resp)
        })
    })
}

export function getProducts(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'products/getlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function getProductOptions(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'products/getproductoptionlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function getProductOptionsList(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'productoptions/getlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function getProductOptionValuesList(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'productoptions/getvaluelist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}


export function productOptionAction(http, action, editItem) {
    const req = {
        "action": action,
        "obj": editItem
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'products/changeproductoption', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (resp) => {
            if (resp.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            resolve(resp)
        })
    })
}

export function productAction(http, action, editItem) {
    const req = {
        "action": action,
        "obj": editItem
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'products/change', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (resp) => {
            if (resp.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            resolve(resp)
        })
    })
}

export function getUsers(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'user/getlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function usersAction(http, action, editItem) {
    const req = {
        "action": action,
        "obj": editItem
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'user/change', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (resp) => {
            if (resp.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            resolve(resp)
        })
    })
}


export function uploadFile(http, file) {
    let formData = new FormData();
    formData.append('file', file);
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'tools/upload', formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (resp) => {
            if (resp.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            resolve(resp)
        })
    })
}


export function getInputs(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'revenues/getlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}


export function getPayments(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'payments/getlist' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function callWebservice(http,function_name,req) {

    return new Promise((resolve, reject) => {
        http.post(DOMAIN + function_name, JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            else{
                reject(err)
            }
        })
    })
}

export function functionAction(http, fun, action, editItem, withBody) {
    let req;
    if (withBody === undefined) {
        req = {
            "action": action,
            "obj": editItem
        };
    } else {
        req = editItem
    }
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + fun + '/change', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (resp) => {
            if (resp.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            resolve(resp)
        })
    })
}

export function getFunction(http, func, start, limit, sort, order, filter, fileType) {
    var tURL = "";
    if(func.includes("/")){
        tURL = func;
    }
    else{
        tURL = func + '/getlist';
    }
    
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + tURL + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function productAutoComplete(http, start, limit, sort, order, filter, fileType) {
    const req = {
        "start": start,
        "limit": limit,
        "sort": sort,
        "order": order,
        "filter": filter
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'products/autocomplete' + ((fileType !== undefined) ? '&export=' + fileType : ''), JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function getBillInfo(http, billId, product_barcode) {
    const req = {
        "bill_id": billId,
        "product_barcode": product_barcode
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'bills/getinfo', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }

        })
    })
}

export function updateUserPermissions(http, item) {
    const req = [item];
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'user_category_permissions/change', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
        })
    })
}

export function getInvoiceInfo(http, invoice_id, product_barcode, order_code) {
    const req = {
        "invoice_id": invoice_id,
        "product_barcode": product_barcode,
        "order_code" : order_code
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'invoices/getinfo', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            else{
                reject(err);
            }
        })
    })
}

export function getProductByBarCode(http, barcode) {
    const req = {
        "barcode": barcode
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'products/getbarcodeinfo', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            reject(err)
        })
    })
}

export function signOut(http, toast) {
    http.post(DOMAIN + 'user/signout', '', {
        headers: {
            "metoken": localStorage.getItem('token')
        }
    }).then((resp) => {
        toast.show(resp.message, {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 3000
        });
        window.location.href = BASE_URL + '/pages/login'
    })
}

export function getProductOptionDetails(http, productOptionId) {
    const req = {
        "product_option_id": productOptionId
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'productlocations/getexistlist', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            reject(err)
        })
    })
}

export function getDashboard(http, fromDate, toDate) {
    const req = {
        "from_date": fromDate,
        "to_date": toDate
    };
    return new Promise((resolve, reject) => {
        http.post(DOMAIN + 'common/dashboard', JSON.stringify(req), {
            headers: {
                "metoken": localStorage.getItem('token')
            }
        }).then((resp) => {
            if (resp.status === 200) {
                resolve(resp.body)
            } else {
                reject(resp)
            }
        }, (err) => {
            if (err.status === 401) {
                window.location.href = BASE_URL + '/pages/login'
            }
            reject(err)
        })
    })
}

export function formatDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();

    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes;
    return date.getFullYear() + "-" +  (date.getMonth()+1) + "-" + date.getDate() + " " + strTime;
}
